import { TIME_FORMAT_WITH_UTC } from 'config/constants';
import { Dayjs, dayjs } from 'lib';
import { useRadarViewQuery } from 'queries/scalings';

type useRadarViewDataProps = { modelName?: string; start: Dayjs; end: Dayjs };

export const useRadarViewData = ({ modelName, start, end }: useRadarViewDataProps) => {
  const radarViewQuery = useRadarViewQuery(
    {
      modelName,
      start_date: dayjs(start)?.utc().format(TIME_FORMAT_WITH_UTC),
      end_date: dayjs(end)?.utc().format(TIME_FORMAT_WITH_UTC),
    },
    { retry: false, enabled: !!modelName || !!start || !!end },
  );

  return {
    data: radarViewQuery.data ?? [],
    dateRange: {
      start: dayjs(start).format(TIME_FORMAT_WITH_UTC),
      end: dayjs(end).format(TIME_FORMAT_WITH_UTC),
    },
    error: radarViewQuery.error,
    isLoading: radarViewQuery.isLoading,
    isError: radarViewQuery.isError,
  };
};
